<template>
  <div class="py-8">
    <div class="container mx-auto px-4" v-if="isDone">
      <h2 class="text-orange-500 font-semibold uppercase tracking-wide">Popular Actors</h2>
      <div class="popular-movies text-sm
                        grid grid-cols-2
                        lg:grid-cols-5
                        xl:grid-cols-6 gap-8 pb-14 border-b border-gray-800">
        <div class="actor mt-8" v-for="(actor, index) in actors" :key="index">
          <router-link :to="{name: 'actor', params: {id: actor.id}}" class="">
            <img :src="imagePath(actor.profile_path, actor.name)"
                 alt="actor image"
                 class="hover:opacity-75 ease-in-out transition duration-150 rounded-md">
          </router-link>
          <div class="mt-2">
            <router-link :to="{name: 'actor', params: {id: actor.id}}" class="text-lg hover:text-gray-300">
              {{ actor.name }}
            </router-link>
            <div class="text-sm text-gray-400">
              <i class="fa-solid fa-star text-orange-500 mr-1"></i> {{ Math.ceil(actor.popularity/10)}}%
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-between mt-10">
        <button class="" @click="previousPage">Previous</button>
        <button class="" @click="nextPage">Next</button>
      </div>
    </div>
    <div class="container mx-auto px-4" v-else>
      <div class="flex justify-center items-center min-h-screen pb-28 lg:pb-16">
        <img src="../assets/loading.gif" alt="loading" class="w-80">
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ActorsView",
  data() {
    return {
      actors: [],
      page: 1,
      isDone:false,
    }
  },
  methods: {
    imagePath(image,name) {
      if (image){
        return  'https://image.tmdb.org/t/p/w235_and_h235_face/'+image;
      }else {
        return 'https://ui-avatars.com/api/?size=235&name='+name;
      }
    },
    callApi(page = this.page){
      let token= 'eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI5Y2Q5ZDIzMWMyZWNmOWVlMjMwNTQ1MjY2MDA0NGU1YSIsInN1YiI6IjYyYWMxOGNiZDdjZDA2MDA5Mjk5ZTNiYSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.8aPeoTYZyUOuN72OyZbXh7gDcw6-RhwVJ4vIedUaeFo';
      axios.get(`https://api.themoviedb.org/3/person/popular?page=${page}`,{
        headers: {"Authorization" : `Bearer ${token}`}
      })
      .then(res => this.actors = res.data.results)
      .catch(error => console.log(error));
    },
    previousPage(){
      // this.page > 1 ? this.page-1:null;
      if (this.page > 1){
        this.$router.push({
          name: 'actors.page',
          params: {id: this.page-1}
        })
        this.page -=1;
        this.callApi(this.page);
      }else {
        this.page = 1;
      }
    },
    nextPage(){
      // this.page < 500 ? this.page+1:null;
      if (this.page < 500 ){
        this.$router.push({
          name: 'actors.page',
          params: {id: this.page+1}
        })
        this.page +=1;
        this.callApi(this.page);
      }else {
        this.page = null;
      }
    }
  },
  created() {
    this.callApi();
    setTimeout(() => {
      this.isDone = true;
    }, 2000);
  }
}
</script>

<style scoped>

</style>